import { Bars3Icon } from '@heroicons/react/24/outline';
export const MenuIcon = Bars3Icon;
